import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ProductShowcase from './components/ProductShowcase';
import { productCategories } from '@/mocks/products';

const categories = [
  { key: 'category_shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { key: 'category_hoodies', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-shirt-line' },
  { key: 'category_tshirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { key: 'category_jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-windy-line' },
  { key: 'category_pants', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-layout-bottom-2-line' },
  { key: 'category_headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-headphone-line' },
  { key: 'category_sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { key: 'category_underwear', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-heart-line' },
  { key: 'category_jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-medal-line' },
  { key: 'category_accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-star-line' },
  { key: 'category_bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-shopping-bag-3-line' },
  { key: 'category_belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-links-line' },
  { key: 'category_perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
  { key: 'category_other', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

const articles = [
  {
    slug: 'allchinabuy-spreadsheet-complete-guide',
    titleKey: 'article_allchinabuy_spreadsheet_guide',
    descKey: 'article_allchinabuy_spreadsheet_guide_desc',
    readTime: 12,
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20flat%20lay%20of%20fashion%20shopping%20essentials%20with%20laptop%20spreadsheet%20on%20white%20marble%20desk%2C%20sneakers%20clothing%20accessories%20arranged%20neatly%2C%20bright%20natural%20light%2C%20clean%20editorial%20photography%20style%2C%20soft%20shadows%2C%20warm%20neutral%20tones&width=800&height=500&seq=article-guide-01&orientation=landscape',
  },
  {
    slug: 'allchinabuy-review',
    titleKey: 'article_allchinabuy_review',
    descKey: 'article_allchinabuy_review_desc',
    readTime: 8,
    image: 'https://readdy.ai/api/search-image?query=Person%20unboxing%20fashion%20package%20on%20wooden%20table%2C%20sneakers%20and%20clothing%20items%20spilling%20out%2C%20bright%20daylight%20from%20window%2C%20clean%20minimalist%20photography%20style%2C%20warm%20neutral%20color%20palette%2C%20editorial%20product%20photography&width=800&height=500&seq=article-review-01&orientation=landscape',
  },
  {
    slug: 'allchinabuy-shipping-cost',
    titleKey: 'article_shipping_cost',
    descKey: 'article_shipping_cost_desc',
    readTime: 10,
    image: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20stacked%20neatly%20in%20warehouse%20with%20soft%20natural%20light%2C%20clean%20modern%20logistics%20space%2C%20minimalist%20photography%20style%2C%20warm%20neutral%20tones%2C%20white%20and%20beige%20color%20palette%2C%20editorial%20photography&width=800&height=500&seq=article-shipping-01&orientation=landscape',
  },
  {
    slug: 'allchinabuy-coupon',
    titleKey: 'article_allchinabuy_coupon',
    descKey: 'article_allchinabuy_coupon_desc',
    readTime: 6,
    image: 'https://readdy.ai/api/search-image?query=Hands%20holding%20smartphone%20showing%20discount%20coupon%20app%20screen%2C%20shopping%20bags%20in%20background%20soft%20focus%2C%20bright%20clean%20studio%20lighting%2C%20minimalist%20photography%20style%2C%20warm%20neutral%20tones%2C%20lifestyle%20editorial%20photography&width=800&height=500&seq=article-coupon-01&orientation=landscape',
  },
  {
    slug: 'allchinabuy-vs-superbuy',
    titleKey: 'article_allchinabuy_vs',
    descKey: 'article_allchinabuy_vs_desc',
    readTime: 9,
    image: 'https://readdy.ai/api/search-image?query=Two%20smartphones%20side%20by%20side%20on%20white%20marble%20surface%20showing%20shopping%20app%20interfaces%2C%20minimalist%20comparison%20visual%2C%20clean%20bright%20lighting%2C%20soft%20shadows%2C%20neutral%20warm%20tones%2C%20editorial%20product%20photography&width=800&height=500&seq=article-vs-01&orientation=landscape',
  },
  {
    slug: 'allchinabuy-legit-safety',
    titleKey: 'article_allchinabuy_legit',
    descKey: 'article_allchinabuy_legit_desc',
    readTime: 7,
    image: 'https://readdy.ai/api/search-image?query=Secure%20lock%20icon%20with%20shopping%20cart%20on%20clean%20white%20background%2C%20minimalist%203D%20render%20style%2C%20soft%20pastel%20colors%2C%20modern%20security%20concept%20visual%2C%20warm%20neutral%20tones%2C%20clean%20product%20photography%20style&width=800&height=500&seq=article-safety-01&orientation=landscape',
  },
];

const faqs = [
  { q: 'faq_1_q', a: 'faq_1_a' },
  { q: 'faq_2_q', a: 'faq_2_a' },
  { q: 'faq_3_q', a: 'faq_3_a' },
  { q: 'faq_4_q', a: 'faq_4_a' },
  { q: 'faq_5_q', a: 'faq_5_a' },
  { q: 'faq_6_q', a: 'faq_6_a' },
  { q: 'faq_7_q', a: 'faq_7_a' },
  { q: 'faq_8_q', a: 'faq_8_a' },
];

export default function Home() {
  const { t } = useTranslation();
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const filteredArticles = articles.filter(article =>
    t(article.titleKey).toLowerCase().includes(searchQuery.toLowerCase()) ||
    t(article.descKey).toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-stone-50">
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-[600px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://readdy.ai/api/search-image?query=Beautiful%20aerial%20view%20of%20luxury%20fashion%20boutique%20interior%20with%20clothing%20racks%20and%20shoe%20displays%2C%20warm%20soft%20lighting%2C%20cream%20and%20beige%20color%20palette%2C%20editorial%20fashion%20photography%20style%2C%20minimalist%20elegant%20composition%2C%20high%20end%20retail%20aesthetic&width=1920&height=1080&seq=hero-bg-01&orientation=landscape"
            alt="AllChinaBuy Spreadsheet Fashion Shopping"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        </div>

        <div className={`relative z-10 w-full px-4 sm:px-6 lg:px-8 xl:px-12 text-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="max-w-4xl mx-auto">
            <span className="inline-block px-4 py-1.5 mb-6 text-xs font-medium tracking-wider uppercase text-white/90 bg-white/10 backdrop-blur-sm rounded-full border border-white/20">
              2026 Resource Hub
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 tracking-tight">
              {t('hero_h1')}
            </h1>
            <p className="text-base md:text-lg text-white/80 mb-10 max-w-2xl mx-auto leading-relaxed">
              {t('hero_subtitle')}
            </p>

            {/* Search Bar */}
            <div className="max-w-xl mx-auto mb-8">
              <div className="relative flex items-center bg-white/95 backdrop-blur-md rounded-2xl shadow-lg overflow-hidden">
                <i className="ri-search-line absolute left-4 text-stone-400 text-lg"></i>
                <input
                  type="text"
                  placeholder={t('hero_search_placeholder')}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-12 pr-4 py-4 text-sm text-stone-800 bg-transparent outline-none placeholder:text-stone-400"
                />
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-4 text-base font-medium bg-white text-stone-900 rounded-xl hover:bg-stone-100 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
              >
                {t('hero_cta_primary')}
                <i className="ri-external-link-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-4 text-base font-medium bg-stone-800/80 backdrop-blur-sm text-white rounded-xl hover:bg-stone-800 transition-all border border-white/20 cursor-pointer whitespace-nowrap"
              >
                {t('hero_cta_secondary')}
                <i className="ri-shopping-cart-line"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Categories Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-bold text-stone-900 mb-4">{t('categories_title')}</h2>
            <p className="text-stone-500 max-w-2xl mx-auto">{t('categories_subtitle')}</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4 max-w-6xl mx-auto">
            {categories.map((cat) => (
              <a
                key={cat.key}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-2xl bg-stone-50 hover:bg-stone-100 border border-stone-100 hover:border-stone-200 transition-all cursor-pointer"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-white shadow-sm flex items-center justify-center group-hover:scale-110 transition-transform">
                  <i className={`${cat.icon} text-xl text-stone-600 group-hover:text-stone-900`}></i>
                </div>
                <span className="text-xs md:text-sm font-medium text-stone-700 text-center leading-tight">{t(cat.key)}</span>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Product Showcase Section */}
      <ProductShowcase categories={productCategories} />

      {/* Articles Section */}
      <section id="articles" className="py-16 md:py-24 bg-stone-50">
        <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-bold text-stone-900 mb-4">{t('articles_title')}</h2>
            <p className="text-stone-500 max-w-2xl mx-auto">{t('articles_subtitle')}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 max-w-6xl mx-auto">
            {filteredArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/${article.slug}`}
                className="group bg-white rounded-2xl overflow-hidden border border-stone-100 hover:border-stone-200 shadow-sm hover:shadow-lg transition-all cursor-pointer"
              >
                <div className="relative h-48 md:h-56 overflow-hidden">
                  <img
                    src={article.image}
                    alt={t(article.titleKey)}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 text-xs font-medium bg-white/90 backdrop-blur-sm rounded-lg text-stone-600">
                      {article.readTime} {t('article_read_time')}
                    </span>
                  </div>
                </div>
                <div className="p-5 md:p-6">
                  <h3 className="text-base md:text-lg font-semibold text-stone-900 mb-2 group-hover:text-stone-700 transition-colors leading-snug">
                    {t(article.titleKey)}
                  </h3>
                  <p className="text-sm text-stone-500 leading-relaxed mb-4 line-clamp-2">
                    {t(article.descKey)}
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-sm font-medium text-stone-700 group-hover:text-stone-900 transition-colors">
                    {t('article_read_more')}
                    <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform"></i>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-bold text-stone-900 mb-4">{t('faq_title')}</h2>
          </div>

          <div className="max-w-3xl mx-auto space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`border rounded-xl overflow-hidden transition-all ${
                  openFaq === index ? 'border-stone-300 bg-stone-50' : 'border-stone-200 bg-white'
                }`}
              >
                <button
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                  className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                  type="button"
                >
                  <span className="text-sm md:text-base font-medium text-stone-900 pr-4">{t(faq.q)}</span>
                  <i className={`ri-${openFaq === index ? 'subtract' : 'add'}-line text-lg text-stone-400 flex-shrink-0`}></i>
                </button>
                {openFaq === index && (
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-stone-600 leading-relaxed">{t(faq.a)}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="relative py-20 md:py-28 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20premium%20fashion%20products%20arranged%20on%20light%20wood%20surface%2C%20sneakers%20watches%20bags%20sunglasses%20neatly%20organized%2C%20warm%20soft%20natural%20light%2C%20minimalist%20editorial%20photography%20style%2C%20cream%20beige%20neutral%20color%20palette%2C%20luxury%20shopping%20concept&width=1920&height=800&seq=cta-bg-01&orientation=landscape"
            alt="AllChinaBuy Spreadsheet CTA"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-stone-900/70"></div>
        </div>

        <div className="relative z-10 w-full px-4 sm:px-6 lg:px-8 xl:px-12 text-center">
          <div className="max-w-2xl mx-auto">
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-4">{t('cta_title')}</h2>
            <p className="text-base md:text-lg text-white/70 mb-10">{t('cta_subtitle')}</p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-4 text-base font-medium bg-white text-stone-900 rounded-xl hover:bg-stone-100 transition-all shadow-lg cursor-pointer whitespace-nowrap"
              >
                {t('cta_button')}
                <i className="ri-external-link-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-4 text-base font-medium bg-white/10 backdrop-blur-sm text-white rounded-xl hover:bg-white/20 transition-all border border-white/20 cursor-pointer whitespace-nowrap"
              >
                {t('cta_button_secondary')}
                <i className="ri-shopping-cart-line"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}